import styled from 'styled-components';
import { IProductCard } from './interface';

const base = styled.div<IProductCard>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 16rem;
  height: 16rem;
  margin: 20px;
  padding: 20px;
  cursor: pointer;
  color: #ffffff;
  font-family: parisineclair-regular, Arial, Helvetica, sans-serif;
  font-size: 2rem;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  transition-duration: 100ms;
  background-color: ${(props) =>
    props.isActive
      ? props.theme.colors.mainColor
      : props.theme.colors.desactivated};

  &:hover {
    background-color: ${(props) =>
      props.isActive
        ? props.theme.colors.hover
        : props.theme.colors.desactivated};
    box-shadow: ${(props) =>
      props.isActive
        ? '0px  18px 16px 0px rgba(0, 0, 0, 0.2)'
        : 'box-shadow: 0px 4px 8px 0 rgba(0, 0, 0, 0.2)'};
    transform: scale(1.1);
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
